import React from 'react'
import { Button, Layout } from 'antd'
import { MenuOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import AvatarMenu from '../../components/GlobalHeader/AvatarMenu'
import HelpMenu from '../../components/GlobalHeader/HelpMenu'
import NovuInbox from '../../components/GlobalHeader/NovuInbox'
import SettingsMenu from '../../components/GlobalHeader/SettingsMenu'
import ContextFilterToolbar from '../../features/contextFilters/components/ContextFilterToolbar'
import AppLogo from './AppLogo'

export const HEADER_HEIGHT = 46

const HeaderContent = styled.div`
  display: inline-flex;
  flex: 1;
  gap: 8px;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const HeaderActions = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 16px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.55);
`

interface AppHeaderProps {
  /** Set on mobile, where there is no sider: the header then shows the logo and a button that opens the menu. */
  onOpenMenu?: () => void
}

const AppHeader: React.FC<AppHeaderProps> = ({ onOpenMenu }) => {
  return (
    <Layout.Header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        height: HEADER_HEIGHT,
        lineHeight: `${HEADER_HEIGHT}px`,
        paddingInline: 16,
        // Next to the sider the context filters line up with the content panel's left edge
        paddingInlineStart: onOpenMenu ? 16 : 0
      }}
    >
      {onOpenMenu && <AppLogo />}
      <HeaderContent>
        {onOpenMenu && <Button type="text" onClick={onOpenMenu} style={{ fontSize: 16 }} icon={<MenuOutlined />} />}
        <ContextFilterToolbar />
      </HeaderContent>
      <HeaderActions>
        <NovuInbox />
        <HelpMenu />
        <SettingsMenu />
        <AvatarMenu />
      </HeaderActions>
    </Layout.Header>
  )
}

export default AppHeader
